module.exports = __webpack_public_path__ + "img/world.d8293e7.svg";